import CustomerData from '../Models/CustomerData';
import ApiService, { ApiResponse } from './ApiService';
import { useActiveCustomerStore } from '../features/customer/application/activeCustomerStore';

class CustomerService {
  private readonly api: ApiService;

  constructor() {
    this.api = new ApiService();
  }

  // BHP-1053: the active customer now lives in the shared Zustand store (single
  // source of truth, set by the customer context/switcher against Backend2.0).
  // Legacy /api/v1 callers read it through here, so the `x-active-customer`
  // header and the not-yet-migrated pages follow the same active customer.
  getActiveCustomer(): Promise<CustomerData | null> {
    return new Promise((resolve, reject) => {
      const activeCustomerUuid: string | null =
        CustomerService.getActiveCustomerUuid();

      if (activeCustomerUuid !== null) {
        this.getCustomerByUuid(activeCustomerUuid)
          .then((activeCustomer: CustomerData) => {
            return resolve(activeCustomer);
          })
          .catch(reject);
      } else {
        throw new Error('No active customer found');
      }
    });
  }

  static getActiveCustomerUuid(): string | null {
    return useActiveCustomerStore.getState().activeCustomerUuid;
  }

  getCustomerByUuid(uuid: string): Promise<CustomerData> {
    return new Promise((resolve, reject) => {
      this.api
        .apiCall(`/api/v1/customer/${uuid}`)
        .then((response: ApiResponse) => {
          if (response.status !== 200) {
            return reject(response.meta?.error?.message);
          }
          return resolve(response.data);
        })
        .catch(reject);
    });
  }
}

export default CustomerService;
